import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "react-i18next";

interface PersonalNotesProps {
  note: string;
  onNoteChange: (note: string) => void;
  onSave: () => void;
}

const PersonalNotes = ({ note, onNoteChange, onSave }: PersonalNotesProps) => {
  const { t } = useTranslation();

  return (
    <div className="border-t pt-4">
      <h3 className="flex items-center gap-2 font-semibold mb-2">
        <MessageSquare className="w-4 h-4" />
        {t('products.personalNote')}
      </h3>
      <Textarea
        value={note}
        onChange={(e) => onNoteChange(e.target.value)}
        placeholder={t('products.personalNotePlaceholder')}
        className="mb-2"
      />
      <Button onClick={onSave}>
        {t('products.saveNote')}
      </Button>
    </div>
  );
};

export default PersonalNotes;